import { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Button from "@shared/v2/Button";
import Dropdown from "@shared/v2/Dropdown";
import jobs from "./jobs";

const JOB_OPTIONS = Object.keys(jobs).map((k) => ({ label: k, value: k }));

const JobRunner = (props) => {
  const { accountId, handleSuccess, handleError, userId } = props;
  const [loading, setLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState(JOB_OPTIONS[0].value);

  const onJobSuccess = () => {
    setLoading(false);
    handleSuccess(jobs[selectedJob].successMessage);
  };

  const onJobError = (e) => {
    setLoading(false);
    handleError(e.response.data);
  };

  const runJob = () => {
    const endpoint = jobs[selectedJob].endpoint({ accountId, userId });

    setLoading(true);
    axios.post(endpoint).then(onJobSuccess).catch(onJobError);
  };

  return (
    <div className="tw-flex tw-items-end tw-gap-[8px]">
      <Dropdown
        containerClassName="tw-min-w-[330px]"
        label="Select Job"
        value={JOB_OPTIONS.find((o) => o.value === selectedJob)}
        onChange={(option) => setSelectedJob(option.value)}
        options={JOB_OPTIONS}
        disabled={loading}
      />

      <Button size="medium" onClick={runJob} isLoading={loading}>
        Perform
      </Button>
    </div>
  );
};

JobRunner.propTypes = {
  accountId: PropTypes.number.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
};

export default JobRunner;
